import Vue from 'vue'
import App from './documents/app.vue'
import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter)

document.addEventListener('turbo:load', () => {
  const documents = document.getElementById('documents-vue');

  if (documents) {
    new Vue({
      el: '#documents-vue',
      render: h => h(App)
    }).$mount();
  }
});